import {
  ExperienceActionRequestBodyType,
  ExperienceActionRequestPathParamsType,
  ExperienceActionResponseBodyType,
} from "@intelligems/ig-types";

import { api } from "../api";
import { ApiRequest } from "../types/api";

export const experienceAction = async (
  payload: ApiRequest<
    ExperienceActionRequestBodyType,
    ExperienceActionRequestPathParamsType
  >
) => {
  const resp = await api.post<
    ExperienceActionResponseBodyType,
    ExperienceActionRequestBodyType
  >(
    `/v2/experiences/${payload.pathParams.experienceId}/${payload.pathParams.action}`,
    payload.body
  );
  return resp.data;
};
